﻿window.isue_unscheduledpoll_mask = function () {
	var instance = {
		init: function () {
			im_integer.mask(".integermask");
		}
	};
	var im_integer = Inputmask({
		mask: '9',
		placeholder: "",
		repeat: '*',
		allowMinus: false
	});
	return instance;
}();

class isue_unscheduledpoll_switch extends Tango.Component {
	widgetDidMount() {
		var t = this;
		document.querySelectorAll("input[name*='isexactdatetime']").forEach(function (el) {
			el.onchange = function (e) {
				var cname = e.target.name;
				var other_el = document.querySelectorAll("input[name*='isexactdatetime']:not([name='" + cname + "']")[0];
				t.props.au.state.ctrl[other_el.id].setValue(!e.target.checked);
			};
		});
	}
};

Tango.registerComponent(isue_unscheduledpoll_switch, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils
}));